import React from "react";
import { ItemFilter, FiltersProps } from "../helpers/interfaceHelper";
import ItemFilters from "./ItemFilters";

const problemFitlers: ItemFilter[] = [
    {
        property: "group_name",
        name: "Assigned Group",
        disabled: disabledFilters => disabledFilters.includes("group_name"), 
        endpoint: "ProblemAssignedGroups"
    },
    {
        property: "status_name",
        name: "Status",
        disabled: disabledFilters => disabledFilters.includes("status_name"),
        endpoint: "ProblemStatuses"
    },
    {
        property: "client_name",
        name: "Companies",
        endpoint: "ProblemClients"
    },
    {
        property: "agent_name",
        name: "Agent",
        disabled: disabledFilters => disabledFilters.includes("agent_name"),
        endpoint: "ProblemAgents"
    },
    {
        property: "category",
        name: "Category",
        endpoint: "ProblemCategories"
    },
    {
        property: "sub_category",
        name: "Sub Category",
        endpoint: "ProblemCategories?categoryType=sub"
    },
    {
        property: "item_category",
        name: "Item Category",
        endpoint: "ProblemCategories?categoryType=item"
    }
];

const ProblemsFilters: React.FC<FiltersProps> = ({
    setFilter,
    resetFilter,
    dbViews,
    view,
    setView,
    setDefaultView,
    search,
    setSearch,
    query
}) => (
        <ItemFilters 
            setFilter = {setFilter}
            resetFilter = {resetFilter}
            dbViews = {dbViews}
            view = {view}
            setView = {setView}
            setDefaultView = {setDefaultView}
            search = {search}
            setSearch = {setSearch}
            query = {query}
            filterList = {problemFitlers}
        />
    );

export default ProblemsFilters;